module.exports = __webpack_public_path__ + "img/2.39496c83.jpeg";